import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WorkOrderService, WoChecklistResponse} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';

@Component({
  selector: 'app-wo-checklist-tab',
  templateUrl: './wo-checklist-tab.component.html',
  standalone: false,
})
export class WoChecklistTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;

  checklist: WoChecklistResponse | null = null;
  isLoaded = false;
  saving = false;
  responseOptions = ['pass', 'fail', 'na', 'note'];

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getChecklist(this.headerId).subscribe({
      next: (res) => {
        this.checklist = res;
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  get answeredRequired(): number {
    return this.checklist?.items.filter(i => i.required && i.response).length ?? 0;
  }

  get totalRequired(): number {
    return this.checklist?.items.filter(i => i.required).length ?? 0;
  }

  save(): void {
    if (!this.headerId || !this.checklist) {
      return;
    }
    this.saving = true;
    const responses = this.checklist.items.map(i => ({
      checklist_item_id: i.id,
      response: i.response ?? '',
      notes: i.notes,
    }));
    this.woService.saveChecklist(this.headerId, responses).subscribe({
      next: () => {
        this.notification.showSuccessToast('Checklist saved.');
        this.saving = false;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving checklist.');
        this.saving = false;
      }
    });
  }

  responseClass(response: string | null): string {
    switch (response) {
      case 'pass':
        return 'btn-success';
      case 'fail':
        return 'btn-danger';
      case 'na':
        return 'btn-secondary';
      case 'note':
        return 'btn-warning';
      default:
        return 'btn-outline-secondary';
    }
  }
}
